export enum Action {
    CLICK = 'Click',
    VIEW_GIG = 'View Gig',
    VIEW_SELLER = 'View Seller',
    SAVE = 'Save',
    UN_SAVE = 'Un-Save',
}
